export default "/images/plus.svg?85566e561479b0e785f16fef1bd991cb";